import {
  PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  PHYSICAL_EXAM_SINGLE_CHOICE_INITIAL_VALUES,
  PhysicalExamSectionValues,
  PhysicalExamSingleChoiceValues,
} from "./physical-exams";

export type PerineumAndExternalGenitaliaSections = {
  perineumAndExternalGenitalia: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaVagina: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaCervix: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaUterus: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaAdnexa: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaPerineum: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaEpisiotomy: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaAnus: PhysicalExamSectionValues;
  perineumAndExternalGenitaliaPerineumLaceration: PhysicalExamSingleChoiceValues;
  perineumAndExternalGenitaliaEpisiotomyType: PhysicalExamSingleChoiceValues;
};

export const PERINEUM_AND_EXTERNAL_GENITALIA_FORM_INITIAL_VALUES: {
  sections: PerineumAndExternalGenitaliaSections;
  notes: string;
} = {
  sections: {
    perineumAndExternalGenitalia: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaVagina: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaCervix: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaUterus: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaAdnexa: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaPerineumLaceration: PHYSICAL_EXAM_SINGLE_CHOICE_INITIAL_VALUES,
    perineumAndExternalGenitaliaPerineum: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaEpisiotomyType: PHYSICAL_EXAM_SINGLE_CHOICE_INITIAL_VALUES,
    perineumAndExternalGenitaliaEpisiotomy: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
    perineumAndExternalGenitaliaAnus: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamPerineumAndExternalGenitaliaSections =
  keyof PerineumAndExternalGenitaliaSections;
export type PhysicalExamPerineumAndExternalGenitaliaForm =
  typeof PERINEUM_AND_EXTERNAL_GENITALIA_FORM_INITIAL_VALUES;
